/**
 * API configuration for JvLands Dashboard
 */

// API Base URL configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api-v1.jvlands.com';
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Auth endpoints
export const AUTH_ENDPOINTS = {
    BASE_URL: API_BASE_URL,
    LOGIN: '/api/user/dashboard-login',
};

// Other API endpoints
export const API_ENDPOINTS = {
    // Property related endpoints
    PROPERTIES: {
        RENT: '/api/leads/getAllrent-leads',
        SELL: '/api/leads/getAllSell-leads',
        INVEST: '/api/leads/getAllInvestor-leads',
        JOINT_VENTURE: '/api/leads/getAlljoint-leads',
        AGRICULTURE: '/api/leads/getAllagriculture-leads',
        DOCUMENTS_VERIFICATION: '/api/leads/getAlldocuments-leads',
        DOCUMENTS_VERIFICATION_ADMIN: '/api/verificationDoc/getAllDocuments',
        DOCUMENTS_DOWNLOAD: '/api/leads/download-documents',
        ISSUES: '/api/properties/issues',
        MAINPAGE_STATS: '/api/leads/getAlleads-Count',
    },

    // User related endpoints
    USERS: {
        AGENTS: '/api/users/agents',
        PROFILE: '/api/users/profile',
    },

    // Dashboard endpoints
    DASHBOARD: {
        STATS: '/api/dashboard/stats',
    },

    RENT_PROPERTIES: '/api/rentProperty/getAll-rentProperties',
    SELL_PROPERTIES: '/api/property/getAll-Properties',
    AGRICULTURE_PROPERTIES: '/api/agriculture/getAllProperty',
    JOINT_VENTURE_PROPERTIES: '/api/jvProperty/getAll-jvProperties'
};

// Export common API paths
export default {
    API_BASE_URL,
    AUTH_ENDPOINTS,
    API_ENDPOINTS,
}; 